import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05580acb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "unknown-stats-container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, { icon: "mdi-alert" }),
      _createElementVNode("div", _hoisted_3, " Uh oh... " + _toDisplayString(_ctx.$t('i18n.alertMessage')), 1)
    ])
  ]))
}